<template>
  <footer :class="[$style.root]">
    <div :class="$style.container">
      <div :class="$style.row">
        <div :class="$style.colTwoOfThree">
          <p :class="$style.title">
            Наши контакты
          </p>

          <!-- List of contacts -->
          <ul 
            v-if="$mq !== 'sm'" 
            :class="$style.contactsWrapper"
          >
            <li
              v-for="(item, index) in addresses"
              :key="index"
              :class="[$style.contactsItem, { [$style.tabletHidden]: !item.location}]">
              <p :class="$style.contactsCity">
                <img
                  :class="$style.flag"
                  :src="item.country"
                  alt="Flag"
                  decoding="async"
                >
                {{ item.city }}
              </p>
              <a
                :aria-label="`Ссылка на Google карты ${item.city}`"
                :class="$style.contactsLink"
                :href="item.url"
                target="_blank"
                rel="noreferrer noopener"
                v-html="item.text"
              />
            </li>
          </ul>
          
          <!-- Slider with contacts -->
          <BaseSlider
            v-else
            ref="slick"
            :is-manual-sliding="true"
            :options="sliderOpts"
            :class="$style.slider"
          >
            <div 
              v-for="(address, index) in addresses" 
              :key="index"
            >
              <p :class="$style.contactsCity">
                <img
                  :class="$style.flag"
                  :src="address.country"
                  alt="Flag"
                  decoding="async"
                >
                {{ address.city }}
              </p>
              <a
                :aria-label="`Ссылка на Google карты ${address.city}`"
                :class="$style.contactsLink"
                :href="address.url"
                target="_blank"
                rel="noreferrer noopener" 
                v-html="address.text"
              />
            </div>
          </BaseSlider>
        </div>

        <div :class="$style.colOneOfThree">
          <p :class="[$style.title, $style.titleMb, $style.tabletHidden]">
            Мы в социальных сетях
          </p>
          <div :class="$style.socialWrapper">
            <a
              v-for="(item, index) in social"
              :key="index"
              :class="$style.socialLink"
              :href="item.url"
              :aria-label="`Ссылка на социальную сеть ${item.url}`"
              target="_blank"
              rel="noreferrer noopener"
            >
              <svg-icon
                :id="item.id"
                :width="item.width"
                :height="item.height"
              />
            </a>
          </div>
        </div>
      </div>
      <div :class="$style.row">
        <div :class="$style.colPart">
          <p :class="[$style.copyright, $style.tabletHidden]">
            &copy;2006 - {{ getCurrentYear() }} &laquo;Очень Интересно&raquo;
          </p>
        </div>
        <div :class="$style.colPart">
          <div :class="$style.textRight">
            <a
              :class="$style.privacyLink"
              aria-label="Cсылка на документ политики обработки персональных данных"
              target="_blank"
              rel="noreferrer noopener"
              href="/static/docs/privacy_policy.pdf">Политика обработки персональных данных</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { addresses, social } from 'data/mockCommonInfo';
import BaseSlider from 'components/BaseSlider';

import SvgIcon from 'components/SVGIcon';

export default {
  name: 'TheFooter',
  components: {
    SvgIcon,
    BaseSlider,
  },
  data: () => ({
    addresses,
    social,
    /**
     * Slider options.
     */
    sliderOpts: {
      dots: false,
      arrows: false,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
    },
  }),
  methods: {
    getCurrentYear() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

$footer-color: $blue;
$footer-color-mobile: #2a292b;
$social-icon-color: $red-light;
/* stylelint-disable max-nesting-depth */
/* stylelint-disable*/
.root {
  width: 100%;
  background: $gray-dark;
  color: $white;
  padding: 47px 0 20px;
  text-align: center;

  @include media('<desktop') {
    padding: 40px 0;
  }
}

.container {
  @extend %container;
  max-width: 1230px;
}

.row {
  display: flex;
  flex-flow: row nowrap;
  margin-left: -$grid-gutter;
  margin-right: -$grid-gutter;

  @include media('<desktop') {
    flex-wrap: wrap;
  }

  @include media('<desktop') {
    margin-left: -$grid-gutter-mobile;
    margin-right: -$grid-gutter-mobile;
  }
}

.colOneOfThree {
  width: 33.33%;
  padding-left: $grid-gutter;
  padding-right: $grid-gutter;

  @include media('<desktop') {
    width: 100%;
  }

  @include media('<desktop') {
    padding-left: $grid-gutter-mobile;
    padding-right: $grid-gutter-mobile;
  }
}

.colTwoOfThree {
  width: 66.66%;
  padding-left: $grid-gutter;
  padding-right: $grid-gutter;

  @include media('<desktop') {
    width: 100%;
  }

  @include media('<desktop') {
    padding-left: $grid-gutter-mobile;
    padding-right: $grid-gutter-mobile;
  }
}

.colPart {
  width: 50%;
  padding-left: $grid-gutter;
  padding-right: $grid-gutter;

  @include media('<desktop') {
    width: 100%;
  }

  @include media('<desktop') {
    padding-left: $grid-gutter-mobile;
    padding-right: $grid-gutter-mobile;
  }
}

.textRight {
  text-align: right;

  @include media('<desktop') {
    text-align: center;
  }
}

.title {
  @include set-fz-lh(14, 25);
  color: $white;
  margin: 0;
  margin-bottom: 7px;
}

.titleMb {
  margin-bottom: 27px;
}

.contactsWrapper {
  text-align: left;
  padding: 0;

  @include media('<desktop') {
    align-items: center;
    text-align: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;

    p {
      align-self: center;
    }

    a {
      align-self: start;
    }
  }

  @include media('<tablet') {
    display: block;
  }
}

.contactsItem {
  list-style-type: none;
  width: 33.33%;
  display: inline-block;
  padding-right: 10%;
  margin-bottom: 20px;

  @include media('<desktop') {
    padding-right: 0;
    width: 100%;

    display: grid;
    grid-template-rows: 44px 80px;
  }
}

.contactsCity {
  display: flex;
  align-items: center;

  @include media('<desktop') {
    justify-content: center;
  }
}

.contactsLink {
  @include set-fz-lh(14, 20);
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  color: $white;
  opacity: 0.8;

  @include media('<desktop') {
    white-space: normal;
  }

  &:hover,
  &:focus {
    color: $white;
    text-decoration: underline;
  }
}

.copyright {
  @include set-fz-lh(16, 25);
  margin: 0;
  color: $white;
  text-align: left;
  opacity: 0.8;
}

.privacyLink {
  @include set-fz-lh(16, 25);
  margin: 0;
  color: $white;
  text-align: left;
  opacity: 0.8;
  text-decoration: none;

  &:hover {
    color: $white;
    text-decoration: underline;
  }

  &:visited {
    color: $white;
  }
}

.tabletHidden {
  @include media('<desktop') {
    display: none;
  }
}

.socialWrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  @include media('<desktop') {
    margin-bottom: 17px;
  }
}

.socialLink {
  display: inline-flex;
  margin: 0 9px;

  @include on-event {
    svg {
      fill: $red;
    }
  }
}

.socialLink svg {
  fill: $social-icon-color;
  transition: fill 0.3s;
}

.flag {
  width: 25px;
  margin-right: 5px;
}

.slider {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue